import { ComponentStyleConfig } from '@chakra-ui/react';
import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

const SummaryCard: ComponentStyleConfig = {
  parts: [
    'container',
    'title',
    'secondarytitle',
    'statcontainer',
    'details',
    'footer',
    'icon',
  ],
  baseStyle: (props: StyleFunctionProps) => ({
    container: {
      display: 'flex',
      flexDirection: 'row',
      position: 'relative',
      borderRadius: '5',
      wordWrap: 'break-word',
      bg: mode('white', 'gray.800')(props),
      backgroundClip: 'border-box',
      p: '4',
      height: 'full',
      width: '100%',
      justifyContent: 'space-between',
      alignItems: 'start',
    },
    title: {
      fontSize: 'sm',
      textColor: mode('gray.600', 'gray.800')(props),
    },
    secondarytitle: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 'medium',
      whiteSpace: 'pre',
      textColor: mode('gray.700', 'gray.500')(props),
    },
    statcontainer: {
      display: 'block',
      w: 'full',
      flexDirection: 'column',
      alignItems: 'start',
    },
    details: {
      my: 2,
      fontSize: '2xl',
      fontWeight: 'semibold',
      textColor: mode('gray.800', 'gray.500')(props),
    },
    footer: {
      fontWeight: 'semibold',
      letterSpacing: 'wide',
      fontSize: 'xs',
      textColor: mode('gray.600', 'gray.800')(props),
    },
    icon: {
      ml: '4',
      fontWeight: 'semibold',
      letterSpacing: 'wide',
      fontSize: 'xs',
      textTransform: 'uppercase',
      p: '2',
      borderRadius: 'lg',
      position: 'absolute',
      right: '16px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '40px',
      height: '40px',
    },
  }),
  variants: {
    solid: (props) => ({
      container: {
        shadow: mode('base', 'none')(props),
      },
    }),
    ghost: () => ({
      container: {
        shadow: 'none',
      },
    }),
    outline: (props) => ({
      container: { shadow: mode('xs', 'none')(props) },
    }),
  },
  sizes: {
    xs: () => ({
      container: {
        w: 'xs',
      },
    }),
    sm: () => ({
      container: {
        w: 'sm',
      },
    }),
    md: () => ({
      container: {
        w: 'md',
      },
    }),
    lg: () => ({
      container: { w: 'lg' },
    }),
  },
  defaultProps: {
    variant: 'solid',
  },
};

export default SummaryCard;
